namespace RecordShield.Models.Enums {
    export enum DiscountType {
        FixedValue = 1,
        Percentage = 2
    }
    Serenity.Decorators.registerEnum(DiscountType, 'RecordShield.Models.Enums.DiscountType');
}
